<template>
  <div id="newstrend-page" class="px-2">
    <transition name="block">
      <div class="card card-default m-b-10 shade" style="margin-top: 15px;">
        <div class="card-body">
          <div class="row">
            <div class="col-md-12">
              <div class="d-flex align-items-center">
                <h4><i class="bi bi-graph-up-arrow mr-1"></i> News Trend</h4>
                <button
                  id="add-newstrend-button"
                  aria-label=""
                  v-on:click="addNewTrend"
                  class="btn btn-success btn-icon-left ml-auto"
                  type="button"
                >
                  <i class="bi bi-plus"></i>
                  <span class="">Tambah News Trend</span>
                </button>
              </div>
            </div>
            <div class="col-md-12 mt-3">
              <div class="d-flex align-items-center">
                <div class="mr-1" style="font-size: 14px">Show</div>
                <select
                  v-model="per_page"
                  class="rounded form-control form-custom"
                  style="width: 3rem"
                >
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
                <div class="ml-1" style="font-size: 14px">entries</div>
                <div class="ml-auto mr-2" style="font-size: 14px">Search:</div>
                <input
                  v-model="filter"
                  type="email"
                  class="form-control form-custom rounded"
                  style="width: 11rem"
                />
              </div>
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th scope="col">Judul</th>
                    <th scope="col" class="text-center" width="20%">
                      Tanggal buat
                    </th>
                    <th scope="col" class="text-center" width="15%">Aksi</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="is_loading">
                    <td colspan="3" class="text-center">Loading...</td>
                  </tr>
                  <tr
                    v-else
                    v-for="(item, index) in dataNewsTrend"
                    :key="index"
                  >
                    <td>{{ item.title }}</td>
                    <td class="text-center">
                      {{ dateFormatter(item.created_at) }}
                    </td>
                    <td>
                      <center>
                        <button
                          id="show-detail-newstrend"
                          class="btn btn-primary m-r-5 ch"
                          @click="viewDetail(item._id.$oid)"
                        >
                          <i class="bi bi-eye"></i>
                        </button>
                        <button
                          id="edit-newstrend"
                          class="btn btn-complete m-r-5 edit"
                          @click="editNewTrend(item._id.$oid)"
                        >
                          <i class="bi bi-pencil-square"></i>
                        </button>
                        <button
                          id="delete-newstrend"
                          class="btn btn-danger del"
                          @click="deleteNewsTrend(item._id.$oid)"
                        >
                          <i class="bi bi-trash"></i>
                        </button>
                      </center>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="col-md-12 mt-3">
                <pagination-component
                  v-if="page_info != null"
                  :key="pagination_key"
                  class="pull-right"
                  :data="page_info"
                  :goto="true"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <modal-dynamic-component
      v-if="currentModal"
      :key="modal_key"
      :modal="currentModal"
      :data="modal_data"
      :static="true"
    />
    <v-tour
      v-if="tour_steps.length > 0"
      name="myTour"
      :steps="tour_steps"
      :options="{ highlight: true }"
    />
  </div>
</template>

<script>
import $ from "jquery";
import moment from "moment";
import swal from "sweetalert";
import pagination from "@/views/components/pagination.vue";
import modal_dynamic from "@/views/components/modal_dynamic.vue";
import modal_add_news_trend from "@/views/components/news-trend/modal_add_news_trend.vue";
import modal_edit_news_trend from "@/views/components/news-trend/modal_edit_news_trend.vue";

var modals = {
  title: "Tambah News Trend",
  subtitle: "Silahkan masukan news trend  yang akan ditambahkan",
  component: modal_add_news_trend,
};

var editModals = {
  title: "Edit News Trend",
  subtitle: "Silahkan untuk mengubah news trend yang akan diedit",
  component: modal_edit_news_trend,
};

export default {
  name: "NewsTrend",
  title: "News Trend | Sibernetik",
  components: {
    "modal-dynamic-component": modal_dynamic,
    "pagination-component": pagination,
  },
  data() {
    return {
      id_project: this.$store.getters.user.id_project,
      is_loading: false,
      dataNewsTrend: [],
      modal_key: 0,
      modal_data: null,
      currentModal: null,
      tour_steps: [],
      filter: null,
      page_info: null,
      pagination_key: 0,
      per_page: this.$route.query.items ? this.$route.query.items : 10,
    };
  },
  watch: {
    $route() {
      this.getData();
    },
    per_page(item) {
      if ("items" in this.$route.query) {
        let queries = JSON.parse(JSON.stringify(this.$route.query));
        queries.items = item;
        this.$router.replace({ query: queries });
      } else {
        this.$router.replace({
          query: Object.assign({}, this.$route.query, { items: item }),
        });
      }
    },
    filter() {
      if (this.filter == null || this.filter == "") {
        this.getData();
      } else {
        if ("page" in this.$route.query) {
          let queries = JSON.parse(JSON.stringify(this.$route.query));
          if (queries.page != 1) {
            queries.page = 1;
            this.$router.replace({ query: queries });
          } else {
            this.getData();
          }
        } else {
          this.$router.replace({
            query: Object.assign({}, this.$route.query, { page: 1 }),
          });
        }
      }
    },
  },
  methods: {
    viewDetail: function (id) {
      let params = {
        q: id,
      };
      this.$router.push({ path: "/newstrend/detail", query: params });
    },
    addNewTrend: function () {
      this.modal_key++;
      this.currentModal = modals;
    },
    editNewTrend: function (idNews) {
      this.modal_key++;
      this.currentModal = editModals;
      this.modal_data = idNews;
    },
    dateFormatter: function (date) {
      const date_val = new Date(date * 1000);
      return moment
        .utc(date_val)
        .tz("Asia/Jakarta")
        .locale("id")
        .format("YYYY-MM-DD HH:mm:ss");
    },
    getData: function () {
      this.is_loading = true;
      var params = this.$route.query;
      if (this.filter) {
        params.filter = this.filter;
      } else {
        if (params.filter) {
          delete params.filter;
        }
      }
      let query = Object.keys(params)
        .map((key) => key + "=" + params[key])
        .join("&");
      let api =
        process.env.VUE_APP_API_URL +
        "newstrend/list/" +
        this.id_project +
        "?" +
        query;
      this.$http
        .get(api)
        .then((response) => {
          if (response.status == 200) {
            this.dataNewsTrend = response.data.news_trend;
            this.page_info = response.data.page_info[0];
            this.pagination_key++;
          } else {
            this.dataNewsTrend = [];
            this.page_info = null;
          }
        })
        .catch(() => {
          this.dataNewsTrend = [];
          this.page_info = null;
        })
        .finally(() => {
          this.is_loading = false;
        });
    },
    deleteNewsTrend: function (id) {
      let self = this;
      swal({
        title: "Apakah anda yakin?",
        text: "Akan menghapus news trend tersebut.",
        icon: "warning",
        buttons: ["Tidak", "Ya"],
        dangerMode: true,
      }).then((yess) => {
        if (yess) {
          let params = {
            _id: id,
          };
          let api = process.env.VUE_APP_API_URL + "/newstrend/delete-news";
          this.$http
            .post(api, params)
            .then(function (response) {
              if (response.status == 200) {
                $("body")
                  .pgNotification({
                    style: "bar",
                    message:
                      '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Trend berhasil dihapus.',
                    position: "top",
                    timeout: 2000,
                    type: "success",
                  })
                  .show();
                self.getData();
              }
            })
            .catch(function () {
              $("body")
                .pgNotification({
                  style: "bar",
                  message:
                    '<i class="bi bi-x-circle"></i> <b>Error!</b> Terjadi kesalahan saat menghapus trend.',
                  position: "top",
                  timeout: 4000,
                  type: "danger",
                })
                .show();
            });
        }
      });
    },
  },
  mounted: function () {
    this.getData();
    let v_step = [];
    v_step[0] = {
      target: "#add-newstrend-button",
      header: {
        title: "Tambah News Trend",
      },
      content: "Klik untuk input data News Trend",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[1] = {
      target: "#news_table_filter",
      header: {
        title: "Cari Data Newstrend",
      },
      content:
        "Masukkan kata kunci untuk mencari data Newstrend yang diinginkan",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[2] = {
      target: "#news_table",
      header: {
        title: "Tabel News Trend",
      },
      content: "Menampilkan Data News Trend",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[3] = {
      target: "#show-detail-newstrend",
      header: {
        title: "Tabel News Trend",
      },
      content: "Klik untuk melihat detail Newstrend",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[4] = {
      target: "#edit-newstrend",
      header: {
        title: "Tombol Edit",
      },
      content: "Klik untuk mengedit Newstrend yang dipilih",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[5] = {
      target: "#delete-newstrend",
      header: {
        title: "Tombol Hapus",
      },
      content: "Klik untuk menghapus Newstrend yang dipilih",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    this.tour_steps = v_step;
  },
};
</script>
